import { emptyGuid } from "@insite/client-framework/Common/StringHelpers";
import { Category } from "@insite/client-framework/Services/CategoryService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSelectedCategoryPath } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCatalogPageStateByPath } from "@insite/client-framework/Store/Data/CatalogPages/CatalogPagesSelectors";
import { getCategoryState } from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";

export function getParentCategoriesIds(state: ApplicationState, category: Category) {
    const categories: string[] = [];
    let currentCatId: string | undefined = category.id;

    if (currentCatId) {
        categories.unshift(currentCatId);
        while (currentCatId) {
            const tempCurrentCatId = currentCatId;
            currentCatId = undefined;
            for (const categoryId in state.data.categories.parentCategoryIdToChildrenIds) {
                const subCats = state.data.categories.parentCategoryIdToChildrenIds[categoryId];
                if (subCats?.includes(tempCurrentCatId) && categoryId !== emptyGuid) {
                    categories.unshift(categoryId);
                    currentCatId = categoryId;
                    break;
                }
            }
        }
    }
    return categories;
}

export const getCatalogPageState = (state: ApplicationState) => {
    const location = getLocation(state);
    const selectedCategoryPath = getSelectedCategoryPath(state);
    const categoryPath =
        selectedCategoryPath || (location.pathname.toLowerCase().startsWith("/content/") ? "" : location.pathname);
    return getCatalogPageStateByPath(state, categoryPath);
};

export const getCatalogPage = (state: ApplicationState) => {
    const catalogPageState = getCatalogPageState(state);
    if (catalogPageState) {
        return catalogPageState.value;
    }
};

export const getCategory = (state: ApplicationState) => {
    const catalogPage = getCatalogPage(state);
    if (catalogPage) {
        return getCategoryState(state, catalogPage?.categoryId).value;
    }
};

export const getParentCategories = (state: ApplicationState) => {
    const category = getCategory(state);
    if (category) {
        return getParentCategoriesIds(state, category);
    }
};
